import * as React from "react";
import classNames from "classnames";
import { Icon } from "@blueprintjs/core";
import { QualityStatus } from "../quality-control/qc-stat";

class QualityTag extends React.PureComponent<{ status: QualityStatus }> {
  get text(): string {
    switch (this.props.status) {
      case QualityStatus.Passed:
        return "Passed";
      case QualityStatus.Failed:
        return "Failed";
      case QualityStatus.Caution:
        return "Caution";
      case QualityStatus.Missing:
        return "Missing";
    }
  }

  get icon(): React.ReactNode {
    switch (this.props.status) {
      case QualityStatus.Passed:
        return <Icon icon="tick-circle" />;
      case QualityStatus.Failed:
        return <Icon icon="error" />;
      case QualityStatus.Caution:
        return <Icon icon="warning-sign" />;
      case QualityStatus.Missing:
        return <Icon icon="error" />;
    }
  }

  render() {
    const classes = classNames("quality-tag", {
      "quality-tag--passed": this.props.status === QualityStatus.Passed,
      "quality-tag--failed": this.props.status === QualityStatus.Failed,
      "quality-tag--caution": this.props.status === QualityStatus.Caution,
      "quality-tag--missing": this.props.status === QualityStatus.Missing,
    });

    return (
      <span className={classes}>
        {this.icon}
        {this.text}
      </span>
    );
  }
}

export default QualityTag;
